/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, Fragment } from 'react';
import { View, StyleSheet } from 'react-native';

import {
  Form,
  FormField,
  Label,
  Icon,
  Separator,
  SubmitButton,
  Text,
  TextInputWithError,
  TextInputPassword,
  Alert,
} from '../uiold';
import { themeColors } from '../uiold/Constants';
import { showSuccess } from '../App/AppAlert';

import { postJSON } from '../../support/Fetch';
import AdminModal from './AdminModal';
import { VendorAccount } from '../../types/shared/VendorAccount';

type State = {
  stepNum: number;
  verificationCode: string;
  password: string;
  confirmPassword: string;
  start: number;
  currTime: number;
  isStart: boolean;
  isLoading: boolean;
  error: string | null | undefined;
};

type Props = {
  email: string;
  marketName: string;
  marketAccountID: string;
  onLoginSuccess: (
    vendorAccount: VendorAccount,
    billingLink: string | undefined,
  ) => void;
  onHide: () => void;
};

class RegistrationModal extends Component<Props, State> {
  state: State = {
    stepNum: 1,
    verificationCode: '',
    password: '',
    confirmPassword: '',
    isLoading: false,
    start: 0,
    currTime: 0,
    isStart: false,
    error: null,
  };

  render() {
    let { stepNum, isLoading } = this.state;
    let content = null;
    if (stepNum === 1) {
      content = this._renderEmailVerification();
    } else if (stepNum === 2) {
      content = this._renderCodeInputForm();
    } else {
      content = this._renderPasswordForm();
    }
    return (
      <AdminModal
        title={this.props.marketName}
        isLoading={isLoading}
        onClose={this.props.onHide}
        style={styles.modal}
      >
        <View style={{ alignSelf: 'stretch' }}>
          {this._renderSteps()}
          {content}
        </View>
      </AdminModal>
    );
  }

  _renderSteps = () => {
    let { stepNum } = this.state;
    let stepTitle =
      stepNum === 1
        ? 'Verify email'
        : stepNum === 2
        ? 'Enter verification code'
        : 'Choose a password';
    return (
      <Fragment>
        <View style={styles.steps}>
          <View
            style={[styles.stepCircle, stepNum >= 1 && styles.activeCircle]}
          >
            {stepNum <= 1 ? (
              <Text style={styles.stepCount}>{1}</Text>
            ) : (
              <Icon name="check" size="S" color={themeColors.white} />
            )}
          </View>
          <Separator style={styles.separator} />
          <View
            style={[styles.stepCircle, stepNum >= 2 && styles.activeCircle]}
          >
            {stepNum <= 2 ? (
              <Text style={styles.stepCount}>{2}</Text>
            ) : (
              <Icon name="check" size="S" color={themeColors.white} />
            )}
          </View>
          <Separator style={styles.separator} />
          <View
            style={[styles.stepCircle, stepNum >= 3 && styles.activeCircle]}
          >
            {stepNum <= 3 ? (
              <Text style={styles.stepCount}>{3}</Text>
            ) : (
              <Icon name="check" size="S" color={themeColors.white} />
            )}
          </View>
        </View>
        <View style={styles.heading}>
          <Text style={styles.stepNum}>Step {stepNum}.</Text>
          <Text style={styles.stepTitle}>{stepTitle}</Text>
        </View>
      </Fragment>
    );
  };

  _renderEmailVerification = () => {
    let { email } = this.props;
    return (
      <Form onSubmit={this._sendRequest}>
        <Text style={styles.description}>
          We will send you an email with a one-time code to verify your email
          address.
        </Text>
        <View>{this._renderError()}</View>
        <TextInputWithError
          disabled={true}
          style={styles.textInput}
          value={email}
        />
        <View style={styles.buttonContainer}>
          <SubmitButton title="Confirm Email" />
        </View>
      </Form>
    );
  };

  _renderCodeInputForm = () => {
    let { verificationCode } = this.state;
    return (
      <Form onSubmit={this._checkVerification}>
        <Text style={styles.description}>
          Please enter the one-time code that was sent to your email. This code
          is good for 24 hours.
        </Text>
        <TextInputWithError
          autoFocus
          style={styles.textInput}
          placeholder="Enter your code here"
          value={verificationCode}
          errorMessage={this.state.error}
          checkError={() => !this.state.error}
          onChangeText={(value: string) =>
            this._onFieldChange('verificationCode', value)
          }
        />
        <View style={styles.buttonContainer}>
          <SubmitButton title="Submit" />
        </View>
      </Form>
    );
  };

  _renderPasswordForm = () => {
    let { password, confirmPassword } = this.state;
    return (
      <Form onSubmit={this._onSetPassword}>
        <Text style={styles.description}>
          Your account has been verified. Please set a password for your
          account.
        </Text>
        {this._renderError()}
        <FormField
          render={(id) => (
            <View style={styles.formField}>
              <Label htmlFor={id} style={{ marginBottom: 6 }}>
                Password
              </Label>
              <TextInputPassword
                id={id}
                style={styles.textInput}
                autoFocus
                value={password}
                placeholder="Enter your password here"
                skipFirstCheck
                errorMessage="Minimum length 8; must include uppercase, lowercase and number."
                onChangeText={(value: string) =>
                  this._onFieldChange('password', value)
                }
              />
            </View>
          )}
        />
        <FormField
          render={(id) => (
            <View style={styles.formField}>
              <Label htmlFor={id} style={{ marginBottom: 6 }}>
                Confirm Password
              </Label>
              <TextInputPassword
                id={id}
                style={styles.textInput}
                value={confirmPassword}
                placeholder="Re-enter your password here"
                checkPassword={(password) => password === this.state.password}
                errorMessage="Password does not match."
                onChangeText={(value: string) =>
                  this._onFieldChange('confirmPassword', value)
                }
              />
            </View>
          )}
        />
        <View style={[styles.buttonContainer, { marginTop: 0 }]}>
          <SubmitButton title="Save Password" />
        </View>
      </Form>
    );
  };

  _renderError = () => {
    if (!this.state.error) {
      return;
    }
    return (
      <Alert
        allowMultiline
        type="error"
        onDismiss={this._errorDismiss}
        style={styles.errorAlert}
        text={this.state.error}
      />
    );
  };

  _errorDismiss = () => {
    this.setState({ error: null });
  };

  _sendRequest = () => {
    let { email } = this.props;
    let { marketAccountID } = this.props;
    this.setState({ isLoading: true });
    postJSON(
      '/api/vendor-account/register/email',
      { email, market: marketAccountID },
      (error, data) => {
        if (data && typeof data.error === 'string') {
          this.setState({ isLoading: false, error: data.error });
        } else if (error) {
          this.setState({ isLoading: false, error: error.message });
        } else if (data.success === true) {
          this.setState({ stepNum: 2, isLoading: false, error: null });
        } else {
          this.setState({ isLoading: false, error: 'Unknown error.' });
        }
      },
    );
  };

  _checkVerification = () => {
    let { verificationCode } = this.state;
    let { email, marketAccountID } = this.props;
    this.setState({ isLoading: true });
    postJSON(
      '/api/vendor-account/register/verification',
      { email, verification: verificationCode, market: marketAccountID },
      (error, data) => {
        if (data && typeof data.error === 'string') {
          this.setState({ isLoading: false, error: data.error });
        } else if (error) {
          this.setState({ isLoading: false, error: error.message });
        } else if (data.success === true) {
          this.setState({ stepNum: 3, isLoading: false, error: null });
        } else {
          this.setState({ isLoading: false, error: 'Unknown error.' });
        }
      },
    );
  };

  _loginAttempt = () => {
    let { password } = this.state;
    let { email, marketAccountID, onLoginSuccess } = this.props;
    let reqData = {
      email,
      password,
      market: marketAccountID,
    };
    postJSON('/api/vendor-auth', reqData, (error, data) => {
      if (error && error.status !== 401) {
        this.setState({ error: 'Something went wrong' });
        // TODO: Show error.
      } else if (data.success) {
        const { account, token, billingLink } = data;
        onLoginSuccess({ ...account, token }, billingLink);
        this.props.onHide();
      } else {
        this._loginFail(data as any);
      }
    });
  };

  _loginFail = (data: { error?: string; suspended?: boolean }) => {
    let { error } = data;
    this.setState({ error: error ?? 'Login failed' });
  };

  _onSetPassword = () => {
    let errorText = '';
    let { confirmPassword, password, verificationCode } = this.state;
    let { email, marketAccountID } = this.props;
    if (password.length === 0) {
      errorText = 'Please enter a new password.';
    } else if (confirmPassword.length === 0) {
      errorText = 'Please re-enter your password.';
    } else if (password !== confirmPassword) {
      errorText = 'Password does not match.';
    }
    if (errorText) {
      this.setState({ error: errorText });
      return;
    }
    this.setState({ isLoading: true, error: null });
    postJSON(
      '/api/vendor-account/set-password',
      {
        email,
        password,
        verification: verificationCode,
        market: marketAccountID,
      },
      (error, data) => {
        if (data && typeof data.error === 'string') {
          this.setState({ isLoading: false, error: data.error });
        } else if (error) {
          this.setState({ isLoading: false, error: error.message });
        } else if (data.success === true) {
          this.props.onHide();
          showSuccess('Account has been successfully created. Logging in...');
          this._loginAttempt();
        } else {
          this.setState({ isLoading: false, error: 'Unknown error.' });
        }
      },
    );
  };

  _onFieldChange = (fieldName: string, value: string) => {
    this.setState({ [fieldName]: value, error: null } as any);
  };
}

let styles = StyleSheet.create({
  modal: {
    width: 500,
    minHeight: 350,
  },
  formField: {
    marginBottom: 20,
  },
  description: {
    marginBottom: 20,
  },
  textInput: {},
  errorAlert: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
  },
  steps: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  heading: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 20,
  },
  separator: {
    width: 75,
  },
  stepCircle: {
    backgroundColor: themeColors.grey,
    width: 25,
    height: 25,
    borderRadius: '50%' as any,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 20,
  },
  activeCircle: {
    backgroundColor: themeColors.blue,
  },
  stepCount: {
    color: themeColors.white,
  },
  stepNum: {
    color: themeColors.darkGrey,
    paddingRight: 10,
  },
  stepTitle: {
    fontWeight: '600',
  },
  buttonContainer: {
    marginTop: 20,
    marginBottom: 20,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

export default RegistrationModal;
